import { render } from "./ethetical-making-our-bags.vue?vue&type=template&id=6e159885"
import script from "./ethetical-making-our-bags.vue?vue&type=script&lang=js"
export * from "./ethetical-making-our-bags.vue?vue&type=script&lang=js"

import "./ethetical-making-our-bags.vue?vue&type=style&index=0&id=6e159885&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__